import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { AnimationElement } from "../Components/Elements/Graphics/AnimationElement";

@engineComponent(ComponentTypes.DisplayObject)
export class AnimationSyncedElement extends AnimationElement {
    public static CURRENT_FRAME: number = 0;

    private _isMainSync: boolean = false;

    public updateByNode(node: Element): void {
        if (node.hasAttribute(AnimationSyncedElementAttributes.MAIN_SYNC)) {
            this.setBaseSyncElement(
                StringUtils.parseBoolean(node.getAttribute(AnimationSyncedElementAttributes.MAIN_SYNC)),
            );
        }

        super.updateByNode(node);
    }

    playMe(frame: number = -1): void {
        this._startFrame = AnimationSyncedElement.CURRENT_FRAME;

        super.playMe(frame);
    }

    showMe(frameNumber: number): void {
        if (frameNumber != null) {
            this.gotoAndStop(frameNumber);

            if (this._isMainSync) {
                AnimationSyncedElement.CURRENT_FRAME = frameNumber;
            }
        } else {
            if (this._reverse) {
                this.gotoAndStop(this._endFrame);

                if (this._isMainSync) {
                    AnimationSyncedElement.CURRENT_FRAME = this._endFrame;
                }
            } else {
                this.gotoAndStop(this._startFrame);

                if (this._isMainSync) {
                    AnimationSyncedElement.CURRENT_FRAME = this._startFrame;
                }
            }
        }
    }

    public setBaseSyncElement(isMain: boolean): void {
        if (isMain) {
            this._isMainSync = true;
            this.onFrameChange = this.onFrameUpdate;
        } else {
            this._isMainSync = false;
            this.onFrameChange = null;
        }
    }

    private onFrameUpdate(currentFrame: number): void {
        AnimationSyncedElement.CURRENT_FRAME = currentFrame;
    }

    clone(): AnimationSyncedElement {
        let element: AnimationSyncedElement = new AnimationSyncedElement();

        element._style = this._style;
        element._startFrame = this._startFrame;
        element._endFrame = this._endFrame;
        element._stop = this._stop;
        element._randomStartFrame = this._randomStartFrame;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.rotation = this.rotation;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.skew.x = this.skew.x;
        element.skew.y = this.skew.y;
        element.visible = this.visible;
        element.blendMode = this.blendMode;
        element.tint = this.tint;
        element.name = this.name;
        element.alpha = this.alpha;

        element._isMainSync = this._isMainSync;

        if (this.textures != null && this.textures.length > 0) {
            element.texture = this.texture;
            element.textures = this.textures;
            element.onComplete = element._movieClipComplete.bind(element);
            if (this._style != null && this._style.loop != null) {
                element.loop = this._style.loop;
            }

            element.animationSpeed = this.animationSpeed;

            //element.removeChildren();
            /* todo Potrebujeme ? */
        }

        element.playMe = this.playMe.bind(element);
        element.showMe = this.showMe.bind(element);
        element.stop = this.stop.bind(element);
        //element.getMovieClip = this.getMovieClip.bind(element);

        element.markAsCloned(); // must be called last before return!

        return element;
    }
}

export const AnimationSyncedElementAttributes = {
    MAIN_SYNC: "MainSync",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AnimationSyncedElement.ts
 **/